export default {
  release: '16.5',
  date: 'October 2023',
  releasePostUrl: 'https://docs.gitlab.com/releases/16/gitlab-16-5-released/#this-months-notable-contributor-thorben-westerhuys',
  contributors: [
    {
      name: 'Thorben Westerhuys',
      gitlabUsername: 'n0rdlicht',
    },
  ],
  writeUp: `Thorben was recognized for ongoing work on his merge request to [add a user preference to show
times in 24-hour format](https://gitlab.com/gitlab-org/gitlab/-/merge_requests/130789).
This feature is planned for 16.6 and will give users the choice between 12-hour and 24-hour time formats.

Magdalena Frankiewicz, Product Manager at GitLab, nominated Thorben and noted the issue
for this feature has been open for 7 years with over 190 upvotes. Peter Leitzen, Staff Backend
Engineer at GitLab, also highlighted Thorben's work to [refactor backend code related to time
format](https://gitlab.com/gitlab-org/gitlab/-/merge_requests/130794).

Thorben is CTO of LUUCY, a 3D web platform bringing together high resolution geo data.
He is a former CTO of cividi, a geo spatial data consultancy for urban planning related topics.

Thank you to Thorben and the rest of the GitLab Community for contributing 🙌`,
};
